import { Col, Modal, Row, Input } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { FaCirclePlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Get } from "../../config/api/get";
import { USER } from "../../config/constants/api";
import { useQuery } from "react-query";

const Wallet = () => {
  const [paymentModal, setPaymentModal] = useState(false);
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [amount, setAmount] = useState(null);
  const handleClick = () => {
    setPaymentModal(false);
    navigate("/payment", { state: { type: "WALLET", total: amount } });
  };
  const navigate = useNavigate();
  const fetchUserById = async () => {
    const response = await Get(`${USER.getUser}${userData?._id}`, token);
    if (response?.status) {
      return response?.data?.wallet;
    } else {
      throw new Error("Error fetching user");
    }
  };
  const {
    data: wallet,
    error,
    isLoading,
  } = useQuery(
    ["userWallet", userData?._id], // Unique query key based on the user ID
    fetchUserById,
    {
      enabled: !!userData?._id, // Fetch only if userData._id exists
      retry: 1, // Optional: Retry once if the query fails
      onError: (err) => console.log(err),
    }
  );
  return (
    <div>
      <Row justify="center" className="py-16 max-sm:py-8">
        <Col md={10} sm={22} xs={22}>
          <div className="flex flex-col justify-center items-center">
            <h3 className="text-center font-tavi text-black text-4xl max-sm:text-2xl">
              Wallet
            </h3>
            <div className="bg-img-wallet text-white py-10 px-10 flex flex-col gap-4 mt-8">
              <p className="text-2xl font-bold">Cash</p>
              {wallet && (
                <p className="text-5xl font-bold flex gap-1">
                  <span className="text-2xl font-bold">$</span>
                  {wallet}.00
                </p>
              )}
              <p className="font-bold">Plan ahead, budget easier</p>
              <div
                className="my-8 flex items-center gap-1 cursor-pointer"
                onClick={() => {
                  setPaymentModal(true);
                }}
              >
                <FaCirclePlus style={{ fontSize: "20px" }} />
                <p>Add Cash</p>
              </div>
            </div>
            {/* <img
              src={ImageUrl("credit-card.png")}
              alt="card"
              className="mt-[-10px]"
            /> */}
          </div>
          {/* <div className="flex flex-col justify-center items-center border-y border-gray-300 py-12">
            <h5 className="text-center font-tavi text-black text-2xl max-sm:text-lg">
              Payment Default
            </h5>
            <div className="flex justify-center items-center mt-4">
              <div className="flex flex-col justify-center items-center py-4 w-[170px] max-sm:w-[130px]  rounded-lg shadow-lg sm:mr-8 mr-2">
                <BsPersonFill size={36} className="text-[#82828B]" />
                <h6 className="font-euclid text-sm font-semibold text-customBlack my-1 max-sm:text-xs">
                  Personal
                </h6>
                <p className="font-euclid text-xs text-customGray font-semibold text-center max-sm:text-[10px]">
                  American Express 2008
                </p>
              </div>
              <div className="flex flex-col justify-center items-center py-4 w-[170px] rounded-lg shadow-lg max-sm:w-[130px]">
                <FaSuitcase size={36} className="text-[#82828B]" />
                <h6 className="font-euclid text-sm font-semibold text-customBlack my-1 max-sm:text-xs">
                  Business
                </h6>
                <p className="font-euclid text-xs text-customGray font-semibold text-center max-sm:text-[10px]">
                  Business Profile
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <h5 className="text-center font-tavi text-black text-2xl max-sm:text-lg my-8">
              Payment Method
            </h5>
            <div className="bg-white px-8 rounded-lg shadow-lg w-full">
              <div className="flex justify-between items-center my-4">
                <div className="flex justify-center items-center">
                  <img src={ImageUrl("discover.png")} alt="card" />
                  <p className="font-euclid text-sm font-semibold text-orange-500 ml-2 max-sm:text-xs">
                    Discover 6723
                  </p>
                </div>
                <IoIosArrowForward size={24} className="text-[#82828B]" />
              </div>
              <Divider />
              <div className="flex justify-between items-center my-4">
                <div className="flex justify-center items-center">
                  <img
                    src={ImageUrl("express.png")}
                    alt="card"
                    className="border border-blue-800"
                  />
                  <p className="font-euclid text-sm font-semibold text-customBlack ml-2 max-sm:text-xs">
                    American Express 2008
                  </p>
                </div>
                <IoIosArrowForward size={24} className="text-[#82828B]" />
              </div>
              <Divider />
              <div className="flex justify-between items-center my-4">
                <div className="flex justify-center items-center">
                  <img
                    src={ImageUrl("visa.png")}
                    alt="card"
                    className="border border-black"
                  />
                  <p className="font-euclid text-sm font-semibold text-customBlack ml-2 max-sm:text-xs">
                    Visa 9106
                  </p>
                </div>
                <IoIosArrowForward size={24} className="text-[#82828B]" />
              </div>
              <Divider />
              <div className="flex justify-between items-center my-4">
                <div className="flex justify-center items-center">
                  <img
                    src={ImageUrl("apple.png")}
                    alt="card"
                    className="border border-black"
                  />
                  <p className="font-euclid text-sm font-semibold text-customBlack ml-2 max-sm:text-xs">
                    Apply Pay
                  </p>
                </div>
                <IoIosArrowForward size={24} className="text-[#82828B]" />
              </div>
              <Divider />
              <div className="flex justify-start items-center my-4">
                <div
                  className="flex justify-center items-center cursor-pointer"
                  onClick={() => setPaymentModal(true)}
                >
                  <MdOutlineAddCircle className="text-customGray" size={24} />
                  <p className="font-euclid text-sm font-semibold text-customBlack ml-2 max-sm:text-xs">
                    Add Payment Method
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        </Col>
      </Row>
      <Modal
        centered
        open={paymentModal}
        footer={null}
        onCancel={() => setPaymentModal(false)}
      >
        <div className="my-4">
          <Input
            className="mt-4 p-2"
            type="number"
            placeholder="Enter Amount"
            onChange={(e) => {
              setAmount(e.target.value);
            }}
          />
          <button
            disabled={!amount}
            className={`uppercase py-4 w-full rounded-lg text-sm font-bold max-sm:text-xs max-md:px-4 mt-6 ${
              !amount
                ? "bg-gray-400 cursor-not-allowed text-gray-200" // Style when disabled
                : "bg-button text-white cursor-pointer" // Style when enabled
            }`}
            onClick={handleClick}
          >
            Make Payment
          </button>
        </div>
      </Modal>
      {/* {paymentModal && (
        <PaymentModal
          paymentModal={paymentModal}
          setPaymentModal={setPaymentModal}
        />
      )} */}
    </div>
  );
};

export default Wallet;
